<template>
  <li
    class="cost_item"
    @click="toCostDetail"
  >
    <div class="item_main">
      <h3
        class="cost_name"
        v-text="name"
      />
      <span
        v-if="!status"
        class="remain-operate-span"
      >{{ $t('message["144"]') }}</span>
      <i
        v-else
        class="cubeic-arrow"
      />
    </div>
  </li>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  methods: {
    toCostDetail () {
      this.$router.push({
        name: 'CostDetail',
        query: { 'period': this.id, key: this.title }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.cost_item:last-of-type {
  border-bottom: none;
}
.cost_item {
  height: 48px;
  border-bottom: 1px solid #dbdbdb;
  .item_main {
    position: relative;
    height: 100%;
    margin: auto 12px;
    font-size: 16px;
    line-height: 48px;
    .cost_name {
      color: #333;
      display: inline;
    }
    .cubeic-arrow {
      position: absolute;
      right: 0;
    }
    .remain-operate-span {
      width: 66px;
      height: 30px;
      border-radius: 4px;
      border: solid 1px #5077aa;
      background-image: linear-gradient(to top, #5077aa, #608fcc);
      color: rgba(255, 255, 255, 1);
      font-size: 14px;
      font-weight: 400;
      float: right;
      margin: 9px 0 9px 0;
      line-height: 30px;
      text-align: center;
    }
    .cubeic-arrow {
      color: #ccc
    }
  }
}
</style>
